export default __webpack_public_path__ + "static/media/j44.f616fce2.jpg";